<eight-cap-card [title]="detailHeader">
    <table class="detail">
        <!-- <tr>
            <th colspan="2" class="primary">{{ detailHeader }}</th>
        </tr> -->
        <tr *ngFor="let data of detailData | keyvalue">
            <ng-container *ngIf="data.key !== 'dataType' && !keyDoNotRenderRowView(data.key)">
                <td>{{ data.key | translate }}</td>
                <td>
                    <ng-container
                        *ngIf="
                            !detailData.dataType ||
                            (detailData.dataType &&
                                detailData.dataType[data.key] !== dataType.JSON &&
                                !keyDoNotAllowRenderViewContent(data.key))
                        ">
                        {{ data.value }}
                    </ng-container>

                    <ng-container *ngIf="detailData.dataType && detailData.dataType[data.key] === dataType.JSON">
                        <pre class="json">{{ data.value }}</pre>
                    </ng-container>

                    <ng-container *ngIf="data.value === true">
                        <mat-icon color="primary">check_circle</mat-icon>
                    </ng-container>

                    <ng-container *ngIf="data.value === false">
                        <mat-icon color="warn">cancel</mat-icon>
                    </ng-container>
                    <ng-container *ngIf="data.value === null"> - </ng-container>
                </td>
            </ng-container>
        </tr>
    </table>
</eight-cap-card>

